import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class AppIconRegistryService {
    constructor(
        private readonly matIconRegistry: MatIconRegistry,
        private readonly sanitizer: DomSanitizer
    ) {
        this.registerIcons();
    }

    private registerIcons(): void {
        this.matIconRegistry.addSvgIcon(
            'ego-white',
            this.sanitizer.bypassSecurityTrustResourceUrl('assets/img/ego/svg/EGO_white_icon.svg')
        );
    }
}